// extracted by mini-css-extract-plugin
export var dropdownButton = "_41-0";
export var fullWidthDropdownButton = "_41-1";
export var icon = "_41-3";
export var iconPlaceholder = "_41-2";
export var menuItemRow = "_41-8";
export var separator = "_41-c";
export var shortcutContainer = "_41-7";
export var shortcutIconLg = "_41-6";
export var shortcutIconMd = "_41-5";
export var shortcutIconSm = "_41-4";
export var submenuChevron = "_41-b";
export var submenuDropdown = "_41-9";
export var submenuTriggerRow = "_41-a";